import React from 'react';

const IconArrowLeft = (props) => (
    <svg {...props} className="icon__arrow-left" viewBox="0 0 580 1100">
        <path
            d="m571.021,577.021c-0.59497,0.59399 -1.21997,1.138 -1.85101,1.672l-518.32498,518.32605c-11.647,11.64697 -30.53,11.64697 -42.177,0c-11.647,-11.64709 -11.647,-30.53003 0,-42.177l498.99899,-498.99805l-498.99899,-498.99899c-11.647,-11.647 -11.647,-30.53 0,-42.176c11.647,-11.648 30.53,-11.648 42.177,0l518.32498,518.32502c0.63104,0.534 1.25604,1.078 1.85101,1.672c5.84503,5.84601 8.755,13.51501 8.73199,21.177c0.02301,7.66296 -2.88696,15.33197 -8.73199,21.17798z"
            fillRule="evenodd"
            transform="rotate(180 289.84292602539057,552.8826293945312)"
        />
    </svg>
);

export default IconArrowLeft;
